import { DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Schedule } from '../../models/schedule';
import { Note } from 'src/app/services/notes/note.model';

@Component({
  selector: 'schedule-tab-cell',
  templateUrl: './schedule-tab-cell.component.html',
  styleUrls: ['./schedule-tab-cell.component.scss']
})
export class ScheduleTabCellComponent {
  @Input() schedule!: Schedule;
  @Input() mainProperty?: string; // Accepting actual values instead of strings
  @Input() mainPropertyName?: string;
  @Input() subdetailProperty?: string; // Accepting actual values instead of strings
  @Input() filter?: string;
  @Input() getColor!: (schedule: Schedule, isSubDetail: boolean) => string;
  @Input() deleteNote!: (schedule: Schedule, note: Note) => void;
  @Input() deleteNoteSub!: (schedule: Schedule, note: Note) => void;
  @Input() hutchCondition?: boolean;

  constructor(private datePipe: DatePipe) { }

  ngOnInit() {
    // console.log('Main Property Name:', this.mainPropertyName);
    // console.log('Main Property:', this.mainProperty);
    // console.log('Subdetail Property:', this.subdetailProperty);
  }

  /**
   * Format schedule values for display, normalizing known date-like inputs and composing the extended date cell layout.
   * Preserve non-date strings as entered and switch to subdetail fields when rendering a nested row.
   *
   * @param value Value to render for the cell.
   * @param isSubdetail Use subdetail schedule fields instead of the main schedule fields.
   * @returns Display-ready text or HTML for the cell.
   */
  format(value: any, isSubdetail = false): string {
    if (this.mainPropertyName === 'extendedDate') {
      // Build the two-line extended date display from the appropriate schedule segment.
      if (!isSubdetail) {
        return (this.schedule.extendedDate
          ? this.datePipe.transform(this.schedule.extendedDate, 'M/d/yy') + '<br>'
          : '') +
          (this.schedule.extendedFor
            ? 'Requested for ' + this.datePipe.transform(this.schedule.extendedFor, 'M/d/yy')
            : '');
      }

      return (this.schedule.subdetail?.extendedDate
        ? this.datePipe.transform(this.schedule.subdetail.extendedDate, 'M/d/yy') + '<br>'
        : '') +
        (this.schedule.subdetail?.extendedFor
          ? 'Requested for ' + this.datePipe.transform(this.schedule.subdetail.extendedFor, 'M/d/yy')
          : '');
    }

    // Keep empty values blank so the template does not render placeholder text.
    if (!value) return '';

    if (value instanceof Date) {
      // Format concrete Date instances only when they are valid.
      return isNaN(value.getTime())
        ? ''
        : this.datePipe.transform(value, 'M/d/yy') || '';
    }

    if (typeof value === 'string') {
      const trimmed = value.trim();

      // Only parse strings that match supported ISO or US-style date formats.
      const isoDateRegex =
        /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[+-]\d{2}:\d{2})?)?$/;

      const usDateRegex =
        /^\d{1,2}\/\d{1,2}\/\d{2,4}$/;

      if (!isoDateRegex.test(trimmed) && !usDateRegex.test(trimmed)) {
        return value;
      }

      // Fall back to the original string when parsing fails.
      const parsedDate = new Date(trimmed);

      return isNaN(parsedDate.getTime())
        ? value
        : this.datePipe.transform(parsedDate, 'M/d/yy') || '';
    }

    return String(value);
  }

}
